import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-modal-travelfusion-price-warning',
  templateUrl: './modal-travelfusion-price-warning.component.html',
  standalone: false
})
export class ModalTravelFusionPriceWarning {
  @Input() public price = null;
  @Input() public newPrice = null;
  @Input() public currency = 'GBP';

  constructor(public activeModal: NgbActiveModal) {}
}

LightningModalTypes.ModalTravelFusionPriceWarning.component = ModalTravelFusionPriceWarning;
